module.exports = __webpack_public_path__ + "static/LOGO-e7385d175e4e623c00fb0e5548028777.png";